import { SupplierOnboardingRequestMessage } from '../../../types/SupplierOnboardingRequestMessage';
import { useToasts } from '../../cdl/Toast/useToasts';
import { translate } from '../../common/helpers/translate.helper';
import { useSendOnboarding } from '../hooks/useSendOnboarding';
import { useUpdateSupplierDocuments } from '../hooks/useUpdateSupplierDocuments';

import { SupplierOnboardingDocumentsModal } from './SupplierOnboardingDocumentsModal';

interface SupplierOnboardingUploadModalProps {
    offerId: string;
    supplierId: string;
    onboarding: SupplierOnboardingRequestMessage;
    isOpen: boolean;
    onDismiss: () => void;
}

export const SupplierOnboardingUploadModal = ({
    offerId,
    supplierId,
    onboarding,
    isOpen,
    onDismiss,
}: SupplierOnboardingUploadModalProps) => {
    const updateDocuments = useUpdateSupplierDocuments();
    const sendDocuments = useSendOnboarding();
    const { addToast, addErrorToast } = useToasts();

    const submittedDocuments = onboarding.supplierDocuments.filter((document) => document.submitted);
    const unsubmittedDocuments = onboarding.supplierDocuments.filter((document) => !document.submitted);

    return (
        <SupplierOnboardingDocumentsModal
            isOpen={isOpen}
            title={translate('supplierOnboarding.modal.uploadTitle')}
            emptyTitle={translate('supplierOnboarding.modal.upload.emptyTitle')}
            emptyDescription={translate('supplierOnboarding.modal.upload.emptyDescription')}
            submitLabel={translate('supplierOnboarding.modal.uploadSubmit')}
            companyId={supplierId}
            documents={unsubmittedDocuments}
            readOnlyDocuments={submittedDocuments}
            isPersisting={updateDocuments.isPending}
            isSending={sendDocuments.isPending}
            onPersist={async (fileIds) => {
                try {
                    await updateDocuments.mutateAsync({
                        offerId,
                        fileIds: [...submittedDocuments.map((document) => document.fileId), ...fileIds],
                    });
                } catch {
                    addErrorToast(translate('supplierOnboarding.saveError'));
                }
            }}
            onSubmit={() =>
                sendDocuments.mutate(offerId, {
                    onSuccess: () => {
                        addToast(translate('supplierOnboarding.submitSuccess'));
                        onDismiss();
                    },
                    onError: () => addErrorToast(translate('supplierOnboarding.submitError')),
                })
            }
            onDismiss={onDismiss}
        />
    );
};
